<template>
  <div class="team-detail">
    <content-header>
      <div class="header-left-box" slot="header-left">
        <div class="return-prev" @click="retuenPrev">
          <span class="icon-box">
            <span class="el-icon-arrow-left"></span>
          </span>
          <span class="return-text">{{ $t('studentDetail.FH') }}</span>
        </div>
        <content-header-title>
          <span>{{
              !isStudentLogin
                ? $t('studentDetail.CK')
                : teamData.planDto && teamData.planDto.planName
          }}
          </span>
        </content-header-title>
      </div>
      <div class="header-left-box" slot="header-right">
        <el-button type="primary" v-if="isBtn.btnEntryPractise" @click="goRace" size="small">
          {{ $t('studentDetail.JRLX') }}</el-button>
        <el-button type="primary" v-if="isBtn.btnResetPractise" @click="resetMatch"
          v-auth="[['teacher', 'student'], 'pro']" size="small">
          {{ $t('studentDetail.CZLX') }}</el-button>
      </div>
    </content-header>
    <div class="main">
      <content-left :teamData="teamData"></content-left>
      <div class="content-right">
        <div>
          <tableTitle>
            <div class="header-left" slot="header-left">{{ $t('studentDetail.LXJL') }}</div>
          </tableTitle>
          <div class="table-box">
            <c-table @operation="operation" :tableData="teamData.subVersionLogList" :ISChangeCheckout="false"
              :tableHeader="lxTableHeaderFilter" :TableHeight="`calc( 100vh - ${240}px)`">
            </c-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contentLeft from "./content-left";
import tableTitle from ".//table-title";
import mins from "./mins";
import CTable from "@/components/table";
import fetch from "@/api/fetch";
import { Base64 } from "js-base64";
import {getStore, setStore} from '@/utils/common.js'
export default {
  name: "studentDetail",
  components: {
    contentLeft,
    tableTitle,
    CTable,
  },
  mixins: [mins],
  data() {
    return {
      isStudentLogin: false,
      planDatas: {},
    };
  },
  computed: {
    isBtn() {
      try {
        return this.isStudentLogin
          ? this.teamData.pageBtnStatusDto.btnInnerStatus
          : JSON.parse(this.$route.query.btn);
      } catch {
        return {};
      }
    },
    queryData() {
      return JSON.parse(sessionStorage.getItem("queryData"));
    },
  },
  created() {
    this.planDatas = JSON.parse(
      Base64.decode(JSON.stringify(this.$route.query.q))
    );
    this.isStudentLogin =
      this.planDatas.playerId === "false" || !this.planDatas.playerId;
    this.getData();
  },
  methods: {
    retuenPrev() {
      let url;
      if( this.$route.name == 'studentDetail') {
         if(getStore("personalPlanDetail")) {
          url = JSON.parse(getStore("personalPlanDetail"));
         } else {
           if(getStore('planHomeUrl')) {
             url = JSON.parse(getStore("planHomeUrl"));
           } else {
             this.$router.go(-1)
           }
         }
      } else {
         url = JSON.parse(getStore("planHomeUrl"));
      }
      this.$router.push(url);
    },
    getData() {
      let { id, planId } = this.planDatas;
      let params = {
        planId: id || planId,
        playerId: this.planDatas.playerId,
      };
      this.isStudentLogin ? delete params.playerId : "";
      fetch[this.isStudentLogin ? "entryShow" : "playerDetail"](params).then(
        (res) => {
          if (res.code == 0) {
            this.isStudentLogin ? setStore('isOpenPaperCopy', res.data.planDto.isOpenPaperCopy.toString()): false
            this.teamData = this.isStudentLogin
              ? { ...res.data.playerDto, ...res.data }
              : res.data;
            this.teamData.subVersionLogList = res.data.subVersionLogList
              ? res.data.subVersionLogList.map((item) => ({
                startTimeSubmitTime: item.startTime + "-" + item.submitTime,
                ...item,
                totalScore:
                  item.startTime && item.submitTime
                    ? Number(item.score).toFixed(2)
                    : "--",
              }))
              : [];
            // this.teamData.subVersionLogList = [{}]
          }else{
            this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg , type: 'error' });
            this.$router.go(-1)
          }
        }
      );
    },
    operation(type, rowData) {
      let params = {
        pattern_lx: this.planDatas.pattern_lx,
        playerId: rowData.playerId,
        planId: rowData.planId,
        keyId: rowData.id,
        answerFlag: this.planData.answerFlag,
        mainVersion: rowData.mainVersion,
        subVersion: rowData.subVersion,
      };
      let params_jam = Base64.encode(JSON.stringify(params));

      if (type === "show") {
        sessionStorage.setItem(
          "StudentDetailUrl",
          JSON.stringify(this.$route.fullPath)
        );
        this.$router.push(`/showLxRecordStudent?q=${params_jam}`);
      } else if (type === "addRemoveStudent") {
        // 清除或添加学生
        if (rowData.playerName) {
          // 清除学生
          let item =
            this.teamData.memberList[
            this.teamData.memberList.findIndex(
              (item) => item.stationId === rowData.stationId
            )
            ];
          (item.playerName = ""),
            (item.playerNo = ""),
            (item.playerId = ""),
            (item.userId = "");
        } else {
          this.tableActiveIndex = this.teamData.memberList.findIndex(
            (item) => item.stationId === rowData.stationId
          );
        }
      } else if (type === "stationIdChange") {
        let item = this.teamData.memberList.find(
          (item) => item.stationAddId === rowData.stationAddId
        );
        item.stationAddId = rowData.stationPrevId;
        rowData.stationPrevId = rowData.stationAddId;
        item.stationPrevId = item.stationAddId;
      }
    },
    resetMatch() {
      // 重置练习
      let funAxiosNext = () => {
        fetch
          .matchReset({
            planId: this.planDatas.id,
            playerId: this.planDatas.playerId
              ? this.planDatas.playerId
              : this.teamData.playerId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$notify({
                title: this.$t('studentDetail.CZ'),
                message: this.$t('studentDetail.CZCG'),
                type: "success",
              });
            } else {
              this.$notify({
                title: this.$t('studentDetail.CZ'),
                message: res.msg || this.$t('studentDetail.SB'),
                type: "error",
              });
            }
          });
      };
      if (this.queryData.professionId === 8) {
        funAxiosNext();
      } else {
        this.$confirm(
          this.$t('studentDetail.CZ') + sessionStorage.getItem(
            "initInterval"
          ) + this.$t('studentDetail.FZCKYJX'),
          this.$t('studentDetail.TS'),
          {
            confirmButtonText: this.$t('studentDetail.QD'),
            cancelButtonText: this.$t('studentDetail.QX'),
            type: "warning",
          }
        ).then(() => {
          funAxiosNext();
        });
      }
    },
    goRace() {
      localStorage.setItem("pattern_lx", this.planDatas.pattern_lx);
      let { answerFlag, scoreFlag, schemeId } = JSON.parse(
        Base64.decode(this.$route.query.q)
      );
      let params = {
        dev: true,
        answerFlag,
        scoreFlag,
        schemeId,
        pattern_lx: this.planDatas.pattern_lx,
        planId: this.teamData.planId,
        orgId: this.__userData.orgId,
        mainVersion: this.teamData.mainVersion,
        subVersion: this.teamData.subVersion,
        userId: this.__userData.userId,
      };
      // let params_jam = Base64.encode(JSON.stringify(params));
      // window.open(`/#/examHome?q=${params_jam}`);
      this.getPlayerInfo(params);
      // this.$router.push(`/examHome?q=${params_jam}`)
    },
    getPlayerInfo(params) {
      let params_jam = Base64.encode(JSON.stringify(params));
      fetch.racePlayerDetail(params).then((res) => {
        if (res.data.initStatus <= 1) {
          this.$confirm(
            this.$t('studentDetail.BCLXZTSJ'),
            this.$t('studentDetail.TS'),
            {
              confirmButtonText: this.$t('studentDetail.QD'),
              cancelButtonText: this.$t('studentDetail.QX'),
              type: "warning",
            }
          )
            .then(() => {
              this.goRaceHome(params, params_jam, res);
            })
            .catch(() => { });
        } else {
          this.goRaceHome(params, params_jam, res);
        }
      });
    },
    goRaceHome(params, params_jam, res) {
      if (this.$route.path === "/examHome") {
        return false;
      }
      localStorage.setItem("matchPlanId", params.planId);
      localStorage.setItem("playerInfo", JSON.stringify(res.data));
      localStorage.setItem("resultVal", JSON.stringify(res.data));
      sessionStorage.setItem("prevUrl", location.href.split("/#/")[1]);
      localStorage.setItem(
        "isOpenFile",
        this.teamData.planDto.isOpenFile ? this.teamData.planDto.isOpenFile : 0
      );
      let url = `/examHome?q=${params_jam}`;
      this.$router.push(url);
    },
    teamDelete() {
      fetch
        .teamDelete({
          planId: this.planId,
          teamId: this.teamId, // --团队id
        })
        .then((res) => {
          if (res.code == 0) {
            this.$router.go(-1);
            this.$notify({
              title: this.$t('studentDetail.CZ'),
              message: this.$t('studentDetail.CZCG'),
              type: "success",
            });
          } else {
            this.$notify({
              title: this.$t('studentDetail.CZ'),
              message: res.msg || this.$t('studentDetail.CZSB'),
              type: "warning",
            });
          }
        });
    },
    saveTeam(teamName) {
      let params = {
        planId: this.planId,
        teamId: this.isStudentLogin
          ? this.teamData.teamDto.teamId
          : this.teamId, // --团队id
        teamName:
          typeof teamName === "string" ? teamName : this.teamData.teamName, // --团队名称
        imgUrl: this.isStudentLogin
          ? this.teamData.teamDto.imgUrl
          : this.teamData.imgUrl, // --团队logo
        teamPlayerList: this.teamData.memberList.map((item) => {
          return {
            keyId: item.keyId,
            playerId: item.playerId,
            userId: item.userId,
            stationId: item.stationAddId,
            leaderFlag: item.leaderFlag,
          };
        }),
      };
      fetch.teamUpdate(params).then((res) => {
        if (res.code == 0) {
          this.edit = false;
        } else {
          this.$notify({
            title: this.$t('studentDetail.CZ'),
            message: res.msg || this.$t('studentDetail.CZSB'),
            type: "error",
          });
          this.edit = false;
        }
        this.getData();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-left-box {
  display: flex;

  .return-prev {
    cursor: pointer;
    color: #858c96;

    .icon-box {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #b4bbcd;
      opacity: 0.2;
      text-align: center;
      line-height: 18px;
      font-size: 14px;
      color: #000;
      display: inline-block;
      vertical-align: 1px;
    }

    .return-text {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      letter-spacing: 1px;
      margin: 0 14px 0 6px;
      vertical-align: 1px;
    }
  }

  .return-prev:hover {
    color: #5397f7;

    .icon-box {
      color: #5397f7;
      opacity: 0.5;
    }
  }
}

.main {
  display: flex;
  padding: 10px 24px;
  box-sizing: border-box;
  justify-content: space-between;
  height: calc(100vh - 164px);
}

.content-right {
  display: flex;
  width: calc(100% - 420px);
  flex-direction: column;

  >div {
    flex: 1;
  }
}
</style>